export const createFilterString = (filters) =>
	Object.keys(filters)
		.filter((each) => filters[each] != null)
		.map((each) =>
			!Array.isArray(filters[each])
				? `${encodeURIComponent(each)}=${encodeURIComponent(filters[each])}`
				: filters[each].map((val) => `${encodeURIComponent(each)}=${encodeURIComponent(val)}`).join('&')
		)
		.join('&')
